import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export type JobCreationEntity = 'JOBS' | 'CANDIDATE';

@Injectable({ providedIn: 'root' })
export class JobCreationTriggerService {
  private readonly _trigger = new Subject<JobCreationEntity>();
  readonly trigger$: Observable<JobCreationEntity> = this._trigger.asObservable();

  trigger(entity: JobCreationEntity): void {
    this._trigger.next(entity);
  }
}
